define(function(require) {
    
        /**
         * static inclues
         *
         */
        var self = {};
        var $ = require('jquery');
        var parallax        = document.querySelector("#headerTagline");
        var parallaxText    = document.querySelector("#headerTagline .ce_text, #headerTagline .ce_image:not(.heroSize)");
        
        
        
        /**
         * public functions
         *
         */
        self.setTranslate = function (xPos, yPos, el) {
            el.style.transform = "translate3d(" + xPos + ", " + yPos + "px, 0)";
            
        }
        
        self.opacity = function (params) {
            if (parallaxText) {
                var opacity = -(params / viewport().height) * 2 + 1.6
                parallaxText.style.opacity = opacity
            }
        }

        self.init = function (params) {
            self.setTranslate(0, params * -.4, parallax);
            self.opacity(params)            
        };
    
        
        

        /**
         * do stuff
         *
         */
        return self;
        

        
    
});


//////////////////
// WEBPACK FOOTER
// ./chunk/parallax.js
// module id = 13
// module chunks = 0